import { formatHoursValue, createKpiTileItem } from '../../../../utils/helper';
import { KpiHandler, IPCSummaryData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const hoursOptimized: KpiHandler = {
  type: 'KpiTile',
  handler: (data: IPCSummaryData): KpiData => {
    const { hoursOptimized } = data;

    const formattedValue = formatHoursValue(hoursOptimized);

    return createKpiTileItem(
      'Hours Optimized (Total Hours)',
      formattedValue,
      []
    );
  },
};

export default hoursOptimized;
